module.exports = __webpack_public_path__ + "static/media/waiting-for-process.9124eb96.svg";